module.exports = __webpack_public_path__ + "static/media/no1_100.92b8a306.png";